export default __webpack_public_path__ + "static/media/whitelogo.846c3192.png";